import React from 'react';
import propTypes from 'prop-types';

// components
import ScriptFertilizerApplicationSummary from 'edit/ScriptFertilizerApplicationSummary';
import ScriptSeedApplicationSummary from 'edit/ScriptSeedApplicationSummary';

// constants
import { applicationTypes } from 'constants/scripts';

const ScriptSummaryContainer = ({
  accountCountry,
  applicationType,
  bagSize,
  cropId,
  cropNominalWeight,
  numPopulatedZones,
  numZones,
  showEditAllButton,
  script,
  scriptType,
  scriptTypeIsNitrogen,
  nitrogenApplicationRateType,
  isCustom,
  summary
}) => {
  switch (applicationType) {
    case applicationTypes.APPLICATION:
    case applicationTypes.FERTILIZER:
      return (
        <ScriptFertilizerApplicationSummary
          isCustom={isCustom}
          nitrogenApplicationRateType={nitrogenApplicationRateType}
          numPopulatedZones={numPopulatedZones}
          numZones={numZones}
          script={script}
          scriptType={scriptType}
          scriptTypeIsNitrogen={scriptTypeIsNitrogen}
          showEditAllButton={showEditAllButton}
          summary={summary}
        />
      );
    case applicationTypes.SEED:
      const { avgRate, numSeedBags: { q: numSeedBags } } = summary;
      return (
        <ScriptSeedApplicationSummary
          accountCountry={accountCountry}
          avgRate={avgRate}
          bagSize={bagSize}
          cropId={cropId}
          cropNominalWeight={cropNominalWeight}
          numPopulatedZones={numPopulatedZones}
          numSeedBags={numSeedBags}
          numZones={numZones}
        />
      );
    default:
      return null;
  }
};

ScriptSummaryContainer.propTypes = {
  accountCountry: propTypes.string,
  applicationType: propTypes.string,
  bagSize: propTypes.number,
  cropId: propTypes.number,
  cropNominalWeight: propTypes.number,
  numPopulatedZones: propTypes.number,
  numZones: propTypes.number,
  script: propTypes.object,
  scriptType: propTypes.string,
  scriptTypeIsNitrogen: propTypes.bool,
  showEditAllButton: propTypes.bool,
  summary: propTypes.object,
  nitrogenApplicationRateType: propTypes.string,
  isCustom: propTypes.bool
};

export default ScriptSummaryContainer;
